import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Swords, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";
import { formatApiErrorDetail } from "@/api";

export default function Login() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0c0d10] px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-white mb-6">
          <ArrowLeft size={15} /> {t("back")}
        </Link>
        <div className="flex items-center gap-2 mb-6">
          <span className="w-10 h-10 grid place-items-center bg-[#E63946] rounded-sm">
            <Swords size={22} className="text-white" />
          </span>
          <span className="font-heading text-2xl font-black uppercase text-white">Guardia<span className="text-[#E63946]">.</span></span>
        </div>
        <h1 className="font-heading text-3xl font-black uppercase text-white">{t("login_title")}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-500">{t("email")}</label>
            <input
              type="email"
              value={email}
              data-testid="login-email-input"
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full bg-[#14161b] border border-[#272b35] rounded-md px-4 py-2.5 text-sm text-white focus:outline-none focus:border-[#E63946]"
              required
            />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-500">{t("password")}</label>
            <input
              type="password"
              value={password}
              data-testid="login-password-input"
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full bg-[#14161b] border border-[#272b35] rounded-md px-4 py-2.5 text-sm text-white focus:outline-none focus:border-[#E63946]"
              required
            />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-[#EF4444]">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#E63946] hover:bg-[#D90429] text-white font-bold uppercase rounded-md disabled:opacity-60"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {t("login_btn")}
          </button>
        </form>
      </div>
    </div>
  );
}
